import gql from 'graphql-tag';
import React, { useState } from 'react';
import withSession from '../../lib/withSession';
import { Input, InputWithLabel } from '../TextInput';
import { MaskInput } from '../MaskInput';
import ConfirmModal from '../ConfirmModal';
import styled from 'styled-components';
import { Box, Button, Flex, Heading, Text } from 'rebass';
import { Mutation, Query } from 'react-apollo';
import SpinLoader from '../SpinLoader';
import { RegionSelectNotForm } from '../RegionSelect';
import Select from 'react-select';
import { keyframes } from 'styled-components';
import PayersDropDown from './PayersDropDown';
import { customDropdownBridgeStyles } from './commons';
import PleaseWait from '../PleaseWait';
import { RUN_BRIDGE_SOFT_ELIGIBILITY } from './softEligibilityForm';
import { GET_BRIDGE_CONSENTS_TO_AGREE } from '../../graphql';
import { ConsentBox } from '../../pages/scheduleDoctor2/components/pickInsurance/onFileInsuranceBridge';
const heartbeat = keyframes`
  0% {
    transform: scale(1)
  }
  10% {
    transform: scale(1.3)
  }
  30% {
    transform: scale(1)
  }
  40% {
    transform: scale(1)
  }
  50% {
    transform: scale(1.3)
  }
  60% {
    transform: scale(1)
  }
  to {
    transform: scale(1)
  }
`;
const slideRight = keyframes`
  0% {
    /* opacity: 0; */
    transform: translateX(100%);
  };
  100% {
    /* opacity: 1; */
    transform: translateX(0);
  };
`;
const AnimateHit = styled.div`
  animation: 1.5s linear ${heartbeat};
  animation-delay: 0.5s;
`;
const AnimateSlide = styled(Flex)`
  animation: 0.3ms linear ${slideRight};
`;
const ModalInner = styled(Flex)`
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const RUN_BRIDGE_HARD_ELIGIBILITY = gql`
  mutation runBridgeHardEligibility($firstName: String!, $lastName: String!, $dob: String!, $state: String!, $payerId: String!, $memberId: String) {
    runBridgeHardEligibility(firstName: $firstName, lastName: $lastName, dob: $dob, state: $state, payerId: $payerId, memberId: $memberId) {
      latest {
        effectiveTo
        effectiveFrom
        validatedAt
        plan
        id
      }
      memberId
      relationship
      status
      payer {
        id
        code
        name
        memberId
        hint
      }
      planName
      id
      errors {
        code
        message
      }
    }
  }
`;

const HardEligibilityForm = ({ session, onContinue, onCancel, onContinueNoInsurance, defaultPayer, setConsents, hideContinueNoInsurance }) => {
  const [step, setStep] = useState('info');
  const [consented, setConsented] = useState([]);

  const handleContinue = (policy) => {
    onContinue(policy);
  };

  return (
    <ConfirmModal confirmLabel="OK" childrenManaged isOpen={true} okOnly onClose={onCancel} onConfirm={onCancel} onBackgroundClick={onCancel} onEscapeKeydown={onCancel}>
      <ModalInner>
        <Flex flexDirection={'column'} style={{ justifyContent: 'center', alignItems: 'center' }}>
          <Flex style={{ width: '420px', padding: '24px', minHeight: '320px', overflowX: 'hidden' }} flexDirection={'column'}>
            <Text style={{ fontSize: '24px', fontWeight: 500, textAlign: 'center' }} mb={4}>
              Coverage Confirmation
            </Text>
            <Query query={GET_BRIDGE_CONSENTS_TO_AGREE}>
              {({ loading: loadingConsents, data: dataConsents }) => {
                return (
                  <Mutation
                    mutation={RUN_BRIDGE_HARD_ELIGIBILITY}
                    awaitRefetchQueries={true}
                    onCompleted={(e) => {
                      if (e.runBridgeHardEligibility) {
                        if (e.runBridgeHardEligibility.status === 'INVALID') {
                          if (step !== 'info') {
                            setStep('info');
                            return;
                          }
                          return;
                        }
                        setStep(e.runBridgeHardEligibility.status);
                      }
                    }}
                  >
                    {(runEligibility, { loading, error, data }) => {
                      return (
                        <Mutation
                          mutation={RUN_BRIDGE_SOFT_ELIGIBILITY}
                          awaitRefetchQueries={true}
                          onCompleted={(e) => {
                            if (e.runBridgeSoftEligibility) {
                              if (e.runBridgeSoftEligibility.status === 'INELIGIBLE') {
                                setStep('INELIGIBLE');
                                return;
                              }
                              // console.log({st: e.runBridgeSoftEligibility.status})
                              // setStep(e.runBridgeSoftEligibility.status);
                            }
                          }}
                        >
                          {(runSoftEligibility, { loading: loadingSoft, error: errorSoft, data: dataSoft }) => {
                            if (step === 'info') {
                              return (
                                <EligibilityInfo
                                  defaultPayer={defaultPayer}
                                  setConsents={setConsents}
                                  session={session}
                                  dataConsents={dataConsents}
                                  consented={consented}
                                  setConsented={setConsented}
                                  loadingConsents={loadingConsents}
                                  errors={data && data.runBridgeHardEligibility ? data.runBridgeHardEligibility.errors : null}
                                  isRunningEligibility={!!loading || !!loadingSoft}
                                  runEligibility={async (firstName, lastName, dob, payerId, state, memberId) => {
                                    const res = await runSoftEligibility({
                                      variables: {
                                        payerId,
                                        state,
                                      },
                                    });
                                    if (res && res.data && res.data.runBridgeSoftEligibility && res.data.runBridgeSoftEligibility.status !== 'INELIGIBLE') {
                                      runEligibility({
                                        variables: {
                                          firstName,
                                          lastName,
                                          dob,
                                          payerId,
                                          state,
                                          memberId,
                                        },
                                      });
                                    }
                                  }}
                                />
                              );
                            } else if (step === 'CONFIRMED') {
                              return <Eligible onContinue={() => handleContinue(data.runBridgeHardEligibility)} />;
                            } else if (step === 'UNKNOWN') {
                              return <Unknown onContinue={() => handleContinue(data.runBridgeHardEligibility)} />;
                            } else if (step === 'INVALID') {
                              return <Invalid goBack={() => setStep('info')} />;
                            } else if (step === 'INELIGIBLE') {
                              return (
                                <Ineligible
                                  state={
                                    dataSoft && dataSoft.runBridgeSoftEligibility && dataSoft.runBridgeSoftEligibility.location
                                      ? dataSoft.runBridgeSoftEligibility.location.state
                                      : data && data.runBridgeHardEligibility && data.runBridgeHardEligibility.location
                                        ? data.runBridgeHardEligibility.location.state
                                        : ''
                                  }
                                  hideContinueNoInsurance={hideContinueNoInsurance}
                                  onChangeInsurance={() => setStep('info')}
                                  onContinueNoInsurance={onContinueNoInsurance}
                                  onCancel={onCancel}
                                />
                              );
                            }
                          }}
                        </Mutation>
                      );
                    }}
                  </Mutation>
                );
              }}
            </Query>
          </Flex>
        </Flex>
      </ModalInner>
    </ConfirmModal>
  );
};

const Unknown = ({ onContinue }) => {
  return (
    <Flex flexDirection={'column'}>
      <AnimateHit style={{ alignSelf: 'center' }} className="animable">
        <svg width="120" height="120" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.92 55.9999H52.08C56.1867 55.9999 58.7467 51.5466 56.6933 47.9999L36.6133 13.3066C34.56 9.75994 29.44 9.75994 27.3867 13.3066L7.30666 47.9999C5.25333 51.5466 7.81333 55.9999 11.92 55.9999ZM32 37.3333C30.5333 37.3333 29.3333 36.1333 29.3333 34.6666V29.3333C29.3333 27.8666 30.5333 26.6666 32 26.6666C33.4667 26.6666 34.6667 27.8666 34.6667 29.3333V34.6666C34.6667 36.1333 33.4667 37.3333 32 37.3333ZM34.6667 47.9999H29.3333V42.6666H34.6667V47.9999Z"
            fill="rgb(255, 148, 17)"
          />
        </svg>
      </AnimateHit>
      <Text mt={3} mb={5} textAlign={'center'} fontWeight={300}>
        There was a problem verifying your insurance. Please continue, and we'll reach out if we need more information..
      </Text>
      <Button variant={'primary'} onContinue={onContinue}>
        Continue
      </Button>
    </Flex>
  );
};

const Ineligible = ({ state, onCancel, onContinueNoInsurance, onChangeInsurance, hideContinueNoInsurance }) => {
  return (
    <Flex flexDirection={'column'}>
      <AnimateHit style={{ alignSelf: 'center' }} className="animable">
        <svg width="120" height="120" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.92 55.9999H52.08C56.1867 55.9999 58.7467 51.5466 56.6933 47.9999L36.6133 13.3066C34.56 9.75994 29.44 9.75994 27.3867 13.3066L7.30666 47.9999C5.25333 51.5466 7.81333 55.9999 11.92 55.9999ZM32 37.3333C30.5333 37.3333 29.3333 36.1333 29.3333 34.6666V29.3333C29.3333 27.8666 30.5333 26.6666 32 26.6666C33.4667 26.6666 34.6667 27.8666 34.6667 29.3333V34.6666C34.6667 36.1333 33.4667 37.3333 32 37.3333ZM34.6667 47.9999H29.3333V42.6666H34.6667V47.9999Z"
            fill="rgb(255, 148, 17)"
          />
        </svg>
      </AnimateHit>
      <Text mt={3} textAlign={'center'} fontWeight={300}>
        Sorry
      </Text>
      <Text mt={3} mb={5} textAlign={'center'} fontWeight={300}>
        Paloma Health does not have Providers that accept your insurance in {state ? state : 'your state'}.
      </Text>
      <Flex flexDirection={'column'} style={{ gap: '12px' }}>
        <Button variant={'outline'} onClick={onChangeInsurance}>
          Try another insurance
        </Button>

        {!hideContinueNoInsurance && (
          <Button variant={'outline'} onClick={onContinueNoInsurance}>
            Continue without insurance
          </Button>
        )}
        <Button variant={'pink'} onClick={onCancel}>
          Cancel
        </Button>
      </Flex>
    </Flex>
  );
};

const Invalid = ({ goBack }) => {
  return (
    <Flex flexDirection={'column'}>
      <AnimateHit style={{ alignSelf: 'center' }} className="animable">
        <svg width="120" height="120" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.92 55.9999H52.08C56.1867 55.9999 58.7467 51.5466 56.6933 47.9999L36.6133 13.3066C34.56 9.75994 29.44 9.75994 27.3867 13.3066L7.30666 47.9999C5.25333 51.5466 7.81333 55.9999 11.92 55.9999ZM32 37.3333C30.5333 37.3333 29.3333 36.1333 29.3333 34.6666V29.3333C29.3333 27.8666 30.5333 26.6666 32 26.6666C33.4667 26.6666 34.6667 27.8666 34.6667 29.3333V34.6666C34.6667 36.1333 33.4667 37.3333 32 37.3333ZM34.6667 47.9999H29.3333V42.6666H34.6667V47.9999Z"
            fill="rgb(255, 148, 17)"
          />
        </svg>
      </AnimateHit>
      <Text mt={3} textAlign={'center'} fontWeight={500}>
        We couldn’t verify your insurance information
      </Text>
      <Text mt={3} mb={5} textAlign={'center'} fontWeight={300}>
        It looks like we weren’t able to find a match with the details you provided. Please double-check your insurance information and try again. If everything looks correct, you may want to contact
        your insurance provider to confirm your coverage details.
      </Text>
      <Flex flexDirection={'column'} style={{ gap: '12px' }}>
        <Button variant={'primary'} onClick={goBack}>
          Go Back
        </Button>
      </Flex>
    </Flex>
  );
};

const Eligible = ({ onContinue }) => {
  return (
    <AnimateSlide flexDirection={'column'}>
      <AnimateHit style={{ alignSelf: 'center' }}>
        <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M60 7.5C73.9239 7.5 87.2774 13.0312 97.1231 22.8769C106.969 32.7226 112.5 46.0761 112.5 60C112.5 73.9239 106.969 87.2774 97.1231 97.1231C87.2774 106.969 73.9239 112.5 60 112.5C46.0761 112.5 32.7226 106.969 22.8769 97.1231C13.0312 87.2774 7.5 73.9239 7.5 60C7.5 46.0761 13.0312 32.7226 22.8769 22.8769C32.7226 13.0312 46.0761 7.5 60 7.5ZM53.46 70.3575L41.7975 58.6875C41.3794 58.2694 40.8831 57.9378 40.3368 57.7115C39.7905 57.4852 39.205 57.3687 38.6137 57.3687C38.0225 57.3687 37.437 57.4852 36.8907 57.7115C36.3444 57.9378 35.8481 58.2694 35.43 58.6875C34.5856 59.5319 34.1112 60.6771 34.1112 61.8713C34.1112 63.0654 34.5856 64.2106 35.43 65.055L50.28 79.905C50.6969 80.3252 51.1929 80.6587 51.7393 80.8864C52.2857 81.114 52.8718 81.2312 53.4637 81.2312C54.0557 81.2312 54.6418 81.114 55.1882 80.8864C55.7346 80.6587 56.2306 80.3252 56.6475 79.905L87.3975 49.1475C87.8212 48.7311 88.1582 48.235 88.3892 47.6877C88.6202 47.1405 88.7405 46.5529 88.7433 45.9588C88.7461 45.3648 88.6312 44.7761 88.4053 44.2267C88.1794 43.6773 87.847 43.1781 87.4272 42.7578C87.0074 42.3375 86.5086 42.0045 85.9594 41.778C85.4103 41.5515 84.8218 41.4359 84.2277 41.4379C83.6337 41.44 83.046 41.5597 82.4984 41.79C81.9509 42.0203 81.4544 42.3568 81.0375 42.78L53.46 70.3575Z"
            fill="#04CF2C"
          />
        </svg>
      </AnimateHit>
      <Text mt={3} textAlign={'center'} fontWeight={300}>
        Good news!
      </Text>
      <Text mt={3} textAlign={'center'} fontWeight={300}>
        Paloma Health is able to work with your insurance provider!
      </Text>
      <Button mt={4} onClick={onContinue} variant={'primary'}>
        Confirm
      </Button>
    </AnimateSlide>
  );
};

const EligibilityInfo = ({ runEligibility, session, isRunningEligibility, errors, dataConsents, consented, setConsented, loadingConsents, setConsents, defaultPayer }) => {
  const [firstName, setFirstName] = useState(session ? session.firstName : null);
  const [lastName, setLastName] = useState(session ? session.lastName : null);
  const [dob, setDob] = useState(session ? session.dob : null);
  const [selectedState, setSelectedState] = useState(session && session.address ? session.address.state : null);
  const [selectedPayer, setSelectedPayer] = useState(defaultPayer);
  const [memberId, setMemberId] = useState();
  const [mustAcceptTerms, setMustAcceptTerms] = useState(false);

  console.log({ selectedPayer, defaultPayer });
  return (
    <Flex flex={1} flexDirection={'column'} style={{ position: 'relative' }}>
      <Flex flexDirection={'column'} style={{ gap: '16px' }}>
        <Text fontSize={'13px'} fontWeight={300} mb={3}>
          Enter your details below to help us determine your insurance coverage
        </Text>
        <Flex style={{ gap: '16px' }}>
          <InputWithLabel
            placeholder={`First Name`}
            value={firstName}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onChange={(e) => {
              setFirstName(e.target.value.toString());
            }}
          />
          <InputWithLabel
            placeholder={`Last Name`}
            value={lastName}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onChange={(e) => {
              setLastName(e.target.value.toString());
            }}
          />
        </Flex>
        <MaskInput name="dob" placeholder="Your Date of Birth (MM/DD/YYYY)" mask="99/99/9999" value={dob} onChange={(e) => setDob(e.target.value)} id="input_dob" />
        <RegionSelectNotForm
          value={selectedState}
          menuPortalTarget={document.body}
          styles={customDropdownBridgeStyles}
          onSelectionChange={(val) => {
            setSelectedState(val);
          }}
          placeholder={'State'}
        />
        <PayersDropDown
          selectedPayer={selectedPayer}
          onPayerChange={(pyr) => {
            setSelectedPayer(pyr);
            setMemberId(null);
          }}
        />
        {((!!selectedPayer && selectedPayer.memberId) || (errors && errors.length > -1 && errors.findIndex((x) => x.code === 'MEMBER_ID') > -1)) && (
          <Flex flexDirection={'column'}>
            <InputWithLabel
              placeholder={`Member ID`}
              value={memberId}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              onChange={(e) => {
                setMemberId(e.target.value.toString());
              }}
            />
            {!!selectedPayer.hint && <Text style={{ fontSize: '13px', fontWeight: 300 }}>{selectedPayer.hint}</Text>}
          </Flex>
        )}
        <Flex flexDirection={'column'} flex={1}>
          {errors &&
            errors.length > 0 && (
              <Flex flexDirection={'column'} style={{ color: 'red' }} mt={4}>
                <Text style={{ fontWeight: 300 }}>Those errors have been returned by the insurance provider. Please verify the accuracy of your inputs:</Text>
                <ul>
                  {errors.map((x) => {
                    return <li key={x.code} style={{ color: 'red', fontWeight: 300 }}>{`${x.code}${x.message ? `: ${x.message}` : ''}`}</li>;
                  })}
                </ul>
              </Flex>
            )}
        </Flex>

        <Button
          mt={4}
          disabled={
            !selectedState ||
            !selectedPayer ||
            !(selectedPayer || {}).id ||
            (!!selectedPayer.memberId && !memberId) ||
            (errors && errors.length > -1 && errors.findIndex((x) => x.code === 'MEMBER_ID') > -1 && !memberId)
          }
          onClick={() => {
            if (dataConsents && dataConsents.getBridgeConsentsToAgree && dataConsents.getBridgeConsentsToAgree.filter((x) => consented.indexOf(x.id) < 0).length > 0) {
              setMustAcceptTerms(true);
              return;
            }
            setConsents(consented);

            runEligibility(firstName, lastName, dob, selectedPayer.bridgeId, selectedState, memberId);
          }}
          variant={'primary'}
        >
          Confirm
        </Button>

        {!!mustAcceptTerms && (
          <ConfirmModal
            isOpen={mustAcceptTerms}
            onClose={() => setMustAcceptTerms(false)}
            onBackgroundClick={() => setMustAcceptTerms(false)}
            onConfirm={() => setMustAcceptTerms(false)}
            childrenManaged
          >
            <ModalInner style={{ alignItems: 'initial', maxWidth: '500px' }}>
              <Heading mb={3}>Patient Consents</Heading>
              <Text mb={3} fontWeight={300}>{`Please review and accept those terms and conditions from Cloud Health Medical Group, our partner`}</Text>

              <Flex style={{ gap: '12px', flexDirection: 'column' }}>
                {!!dataConsents &&
                  dataConsents.getBridgeConsentsToAgree &&
                  dataConsents.getBridgeConsentsToAgree.map((x) => {
                    return (
                      <ConsentBox
                        consent={x}
                        onClick={(e) => {
                          if (consented.findIndex((xx) => xx === x.id) > -1) {
                            setConsented(consented.filter((xx) => xx.id !== x.id));
                          } else {
                            setConsented([...consented, x]);
                          }
                        }}
                        isChecked={consented.findIndex((xx) => xx.id === x.id) > -1}
                      />
                    );
                  })}
              </Flex>

              <Flex mt={3} style={{ borderRadius: '14px', border: '1px solid #ffd3cbf0', backgroundColor: '#9d580721', overflow: 'hidden', padding: '12px 16px' }}>
                <svg width="35" height="20" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.04183 4.87492H5.9585V3.79159H7.04183M7.04183 9.20825H5.9585V5.95825H7.04183M6.50016 1.08325C5.78884 1.08325 5.08447 1.22336 4.42729 1.49557C3.77011 1.76778 3.17298 2.16677 2.67 2.66976C1.65418 3.68558 1.0835 5.06333 1.0835 6.49992C1.0835 7.93651 1.65418 9.31426 2.67 10.3301C3.17298 10.8331 3.77011 11.2321 4.42729 11.5043C5.08447 11.7765 5.78884 11.9166 6.50016 11.9166C7.93675 11.9166 9.3145 11.3459 10.3303 10.3301C11.3461 9.31426 11.9168 7.93651 11.9168 6.49992C11.9168 5.78859 11.7767 5.08423 11.5045 4.42705C11.2323 3.76987 10.8333 3.17274 10.3303 2.66976C9.82734 2.16677 9.23021 1.76778 8.57303 1.49557C7.91585 1.22336 7.21149 1.08325 6.50016 1.08325Z"
                    fill="#9d5807"
                  />
                </svg>

                <Text style={{ fontSize: '14px', fontWeight: 500, color: '#9d5807' }} ml={'6px'}>
                  * Required to continue
                </Text>
              </Flex>

              <Button
                variant="primary"
                mt={4}
                style={{ alignSelf: 'center' }}
                disabled={dataConsents && dataConsents.getBridgeConsentsToAgree && dataConsents.getBridgeConsentsToAgree.filter((x) => consented.findIndex((xx) => xx.id === x.id) < 0).length > 0}
                onClick={() => {
                  setConsents(consented);

                  runEligibility(firstName, lastName, dob, selectedPayer.bridgeId, selectedState, memberId);
                  setMustAcceptTerms(false);
                }}
              >
                Continue
              </Button>
            </ModalInner>
          </ConfirmModal>
        )}
      </Flex>
      {!!isRunningEligibility && (
        <Flex style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255,255,255,0.87)', zIndex: 10000 }} justifyContent={'center'} alignItems={'center'}>
          <PleaseWait text={`Verifying with ${selectedPayer ? selectedPayer.name : ''}`} />
        </Flex>
      )}
    </Flex>
  );
};

export const UnauthenticatedHardEligibilityForm = (props) => {
  return <HardEligibilityForm {...props} />;
};
export default withSession(HardEligibilityForm);
